import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unreadNotifications: 0,
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    updateNotificationCount: (state, action) => {
      state.unreadNotifications = action.payload;
    },
    resetNotificationCount: (state) => {
      state.unreadNotifications = 0;
    },
  },
});

export const { updateNotificationCount, resetNotificationCount } = notificationSlice.actions;
export default notificationSlice.reducer;
